import script from "./esSelectInstitute.vue?vue&type=script&setup=true&lang=ts"
export * from "./esSelectInstitute.vue?vue&type=script&setup=true&lang=ts"

import "./esSelectInstitute.vue?vue&type=style&index=0&id=421ffc02&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-421ffc02"]])

export default __exports__